import Chart from "react-apexcharts";
import { Card, Flex, Typography } from "antd";
import React from "react";

export default function InsuranceConversionRate() {
  const series = [48, 52]; // 48% converted
  const options = {
    chart: { type: "donut" },
    colors: ["#DFDAFF", "#EE615B"],
    labels: ["Insurance Conversion", "Non-Converted"],
    legend: { show: false },
    dataLabels: { enabled: false },
    plotOptions: {
      pie: {
        startAngle: -180,
        endAngle: 180,
        donut: {
          size: "80%",
          labels: {
            show: true,
            name: { show: true },
            total: {
              show: true,
              label: "48%",
              fontSize: "48px",
              fontWeight: 600,
              color: "#6B43B5",
              formatter: function () {
                return "Insurance Conversion";
              },
            },
            value: {
              show: true,
              fontSize: "14px",
              color: "#979797",
              formatter: function () {
                return "Insurance Conversion";
              },
            },
          },
        },
      },
    },
    tooltip: { y: { formatter: (val) => val + "%" } },
  };

  return (
    <Card>
      <Flex vertical>
        <Typography.Title level={4}>Insurance Conversion Rate</Typography.Title>
        <Chart options={options} series={series} type="donut" />
      </Flex>
    </Card>
  );
}
